import type { QualityLevel, QualityRecord } from "types/quality.types"

export const QUALITY_LEVELS: QualityLevel[] = [
  "healthy",
  "degraded",
  "unreliable",
  "invalid",
]

export const isQualityLevel = (value: unknown): value is QualityLevel =>
  QUALITY_LEVELS.includes(value as QualityLevel)

export const aggregateQualityRecords = (records: QualityRecord[]): QualityRecord[] => {
  if (records.length === 0) return []

  const countByLevel = new Map<QualityLevel, number>()

  for (const record of records) {
    countByLevel.set(record.name, (countByLevel.get(record.name) ?? 0) + record.count)
  }

  const totalCount = Array.from(countByLevel.values()).reduce((sum, c) => sum + c, 0)
  if (totalCount === 0) return []

  return QUALITY_LEVELS.filter((level) => countByLevel.has(level)).map((level) => ({
    table: 0,
    result: "_result",
    percentage: ((countByLevel.get(level) as number) / totalCount) * 100,
    count: countByLevel.get(level) as number,
    name: level,
  }))
}

export const mergeQualityResults = (
  ...qualitySets: QualityRecord[][]
): QualityRecord[] => {
  const allRecords = qualitySets.flat()
  return aggregateQualityRecords(allRecords)
}
